<template>
  <fragment>
    <div
      class="vs-accordion-item"
      :dir="direction"
    >
      <button
        :id="'accordion_button_' + id"
        :aria-controls="'accordion_item_' + id"
        :aria-expanded="showAttribute"
        class="vs-btn vs-lead"
        @click="onclick_toggleAccordionItem()"
      >
        {{ buttonText }}
      </button>
      <span
        class="visa-icon visa-icon-caret-up-solid"
        :class="show ? 'vs-active' : ''"
      />
    </div>
    <div
      :id="'accordion_item_' + id"
      role="region"
      :aria-labelledby="'accordion_button_' + id"
      class="vs-accordion-content"
      :class="show ? '' : 'vs-accordion-hide'"
    >
      <slot />
    </div>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import { setDirection } from '@/helpers/direction';
import { generateId } from '@/helpers/generate-id';
import { toBoolean } from '@/helpers/transform';

export default {
  name: 'VsAccordion',
  components: {
    Fragment,
  },
  props: {
    buttonText: { type: String, default: '' },
    direction: { type: String, default: setDirection() },
    showItem: { type: String, default: 'false' },
  },
  data() {
    return {
      id: generateId(),
      show: toBoolean(this.showItem),
    };
  },
  computed: {
    showAttribute() {
      return this.show.toString();
    },
  },
  methods: {
    onclick_toggleAccordionItem() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/accordion/accordionItem';
@import '@/styles/accessibility';
@import '@/styles/core/types/types';
@import '@/styles/buttons/buttons';
@import '@/styles/utilities';
</style>
